import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalCommunity {
  joined: boolean = false;
  communityData: any = {};
  private communityBannerData: any = {}
  private communitGuard: any = {}


  setCommunityBannerData(v: any) {
    this.communityBannerData = v;
  }

  get communityBannerDetails() {
    return this.communityBannerData;
  }

  setCommunityGuard(v: any) {
    this.communitGuard = v;
  }

  get getCommunityGUard() {
    return this.communitGuard;
  }

}